export default __webpack_public_path__ + "static/media/market.fde2447c.png";